import { useMutation } from '@tanstack/react-query';

import { API } from 'src/reactQuery/Api';
import { useMessageHandler } from 'src/utils/hooks/useMessageHandler';
import { putRequest } from 'src/utils/request';

type ImportProjectJobsPayload = {
  file: File;
  forced?: boolean;
};

const getImportProjectJobsEndpoint = (
  projectUuid: string,
  forced?: boolean,
) => {
  if (!forced) {
    return API.PUT.importProjectJobs(projectUuid);
  }

  return `${API.PUT.importProjectJobs(projectUuid)}?forced=true`;
};

const importProjectJobs = async (
  projectUuid: string,
  { file, forced }: ImportProjectJobsPayload,
) => {
  const formData = new FormData();
  formData.append('file', file);

  const res = await putRequest(
    getImportProjectJobsEndpoint(projectUuid, forced),
    formData,
    { headers: { 'content-type': 'multipart/form-data' } },
  );

  return res.data;
};

export const useImportProjectJobs = ({
  projectUuid,
}: {
  projectUuid: string;
}) => {
  const { handleError } = useMessageHandler();

  return useMutation({
    mutationFn: (payload: ImportProjectJobsPayload) =>
      importProjectJobs(projectUuid, payload),
    onError: handleError,
  });
};
